import { Component, OnInit } from '@angular/core';
import { RentalsService } from '../../../../../services/rentals.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import * as XLSX from 'xlsx';
import * as json2csv from 'json2csv'; // convert json file to csv

@Component({
  selector: 'app-rental-affiliate-commission-report',
  templateUrl: './rental-affiliate-commission-report.component.html',
  styleUrls: ['./rental-affiliate-commission-report.component.scss'],
})
export class RentalAffiliateCommissionReportComponent implements OnInit {
  public affiliates: any = [];
  public selectedAffiliates: any = [];
  public affiliateCommssionPayments: any = [];
  public countryData: any = {};
  public partner: any = {};
  public runningReport: boolean = false;
  public loadingAffiliates: boolean = false;
  public startDate: Date = moment().add(-3, 'month').startOf('month').toDate();
  public endDate: Date = moment().endOf('month').toDate();

  constructor(
    private helpersService: HelpersService,
    private rentalsService: RentalsService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.partner = this.helpersService.getPartnerData();
    this.getAffiliates();
  }

  getAffiliates() {
    this.loadingAffiliates = true;
    this.rentalsService
      .getRentalAffiliatesBooking(this.helpersService.getPartnerId())
      .subscribe((affiliates: any) => {
        this.affiliates = affiliates.map((x: any) => {
          return { label: x.affiliateName, value: x.id };
        });
        this.selectedAffiliates = affiliates.map((x: any) => {
          return x.id;
        });
        this.getAffiliateCommisionPayments();
        this.loadingAffiliates = false;
      });
  }

  valid() {
    return (
      !this.loadingAffiliates &&
      !this.runningReport &&
      this.selectedAffiliates &&
      this.selectedAffiliates.length > 0 &&
      this.startDate &&
      this.endDate
    );
  }

  getAffiliateCommisionPayments() {
    if (this.selectedAffiliates && this.selectedAffiliates.length > 0) {
      this.runningReport = true;
      this.rentalsService
        .getRentalAffiliatesCommissionPayments(
          this.helpersService.getPartnerId(),
          this.selectedAffiliates.join(','),
          moment(this.startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
          moment(this.endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        )
        .subscribe((affiliateCommssionPayments: any) => {
          this.affiliateCommssionPayments = affiliateCommssionPayments;
          this.runningReport = false;
        });
    }
  }

  markAsPaid(affiliatePayment) {
    affiliatePayment.busy = true;
    this.rentalsService
      .updateAffiliatePaymentMarkPaid(
        this.helpersService.getPartnerId(),
        affiliatePayment.affiliateID,
        affiliatePayment.affiliatePaymentID,
      )
      .subscribe((result: any) => {
        this.getAffiliateCommisionPayments();
      });
  }

  public downloadFile() {
    var reportData = this.affiliateCommssionPayments.map((x: any) => {
      return {
        [this.translate.instant('bikeshop.rentals.affiliates.affiliate_name')]:
          x.affiliateName,
        [this.translate.instant('bikeshop.report.from_date')]: x.fromDate,
        [this.translate.instant('bikeshop.report.to_date')]: x.toDate,
        [this.translate.instant('bikeshop.rentals.affiliates.rentals_total')]:
          this.partner.CurrencySymbol + x.rentalsTotal.toFixed(2),
        [this.translate.instant(
          'bikeshop.rentals.affiliates.commission_total',
        )]: this.partner.CurrencySymbol + x.commissionAmount.toFixed(2),
        [this.translate.instant('bikeshop.rentals.affiliates.commission')]:
          x.commissionPercentage.toFixed(2) + '%',
        [this.translate.instant('bikeshop.rentals.affiliates.paid')]: x.paid
          ? this.translate.instant('general.yes')
          : this.translate.instant('general.yes'),
        [this.translate.instant(
          'bikeshop.rentals.affiliates.linked_reservations',
        )]: x.linkedReservations
          .map((y: any) => {
            return y.reservationNumber;
          })
          .join(', '),
      };
    });

    var ws = XLSX.utils.json_to_sheet(reportData);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');
    XLSX.writeFile(
      wb,
      (this.selectedAffiliates.length > 1
        ? 'Affiliate Commission Report'
        : this.selectedAffiliates[0].label) + '.xlsx',
    );
  }
}
